export default {
  normal: 'normal' as 'normal',
  bold: 'bold' as 'bold',
}
